<ng-container *transloco="let t;">
     <ul class="d-flex list-group">
        <li class="list-group-item"  [ngClass]="{'active': item.condition_type === 'and' }"  (click)="update('and')" >{{t('Filter predicate and option (Advanced filters) - and')}}</li>
        <li class="list-group-item" [ngClass]="{'active': item.condition_type === 'or' }" (click)="update('or')">{{t('Filter predicate or option (Advanced filters) - or')}}</li>
    </ul>
</ng-container>